import { MutationTree } from 'vuex'
import { IApartmentState } from './apartment-state.store';
import {
  APARTMENT_SET_APPARTMENTS_MASTER,
  APARTMENT_LOADING,
  APARTMENT_SET_APPARTMENT,
  APARTMENT_SET_APPARTMENTS,
  APARTMENT_RESET_APPARTMENTS,
  APARTMENT_SET_PARAMETER,
  APARTMENT_SET_SIDEBAR_APPARTMENTS,
  APARTMENT_SET_APPARTMENTS_PARAMETER_PARTIAL,
  APARTMENT_INIT_APPARTMENT,
  APARTMENT_SET_APARTMENT_BY_FIELD,
  APARTMENT_EXTEND_APARTMENTS,
  APARTMENT_EXTEND_SIDEBAR_APARTMENTS,
  APARTMENT_ACTION,
  APARTMENT_SPLICE_APARTMENTS,
  APARTMENT_SPLICE_SIDEBAR_APARTMENTS,
  APARTMENT_UPDATE_APARTMENTS,
  APARTMENT_UPDATE_SIDEBAR_APARTMENTS,
  APARTMENT_SET_LOCATION_NUMBER, APARTMENT_SET_ZONE, APARTMENT_SET_ZONE_ACTION
} from './apartment-types.store';
import { ActivityStatus, CrudStatus } from '../../common/enums';
import { IApartmentListingViewModel, IApartmentParameter, IApartment } from '../../models/apartment';
import { Pagination } from '../../models/generic';

export const mutations: MutationTree<IApartmentState> = {
  [APARTMENT_LOADING]: (state: IApartmentState, activityStatus: ActivityStatus) => {
    state.activityStatus = activityStatus;
  },
  [APARTMENT_SET_PARAMETER]: (state: IApartmentState, param: IApartmentParameter) => {
    state.apartmentParameter = param;
  },
  [APARTMENT_INIT_APPARTMENT] : (state: IApartmentState, payload: IApartment) => {
    state.apartment = payload
  },
  [APARTMENT_SET_APARTMENT_BY_FIELD] : (state: IApartmentState, payload: { [key:string] : any } ) => {
    state.apartment = {
      ...state.apartment,
      ...payload
    }
  },
  [APARTMENT_SET_APPARTMENTS_MASTER]: (state: IApartmentState, payload: {
    activityStatus: ActivityStatus,
    apartments: any
  }) => {
    state.apartments = payload.apartments;
    state.activityStatus = payload.activityStatus;
  },
  [APARTMENT_SET_APPARTMENTS]: (state: IApartmentState, payload: { pagination: any, apartments: IApartmentListingViewModel[], activityStatus: ActivityStatus, merge: boolean }) => {
    if (payload.merge === false) {
      state.apartments = payload.apartments;
    }
    else {
      const apartments = state.apartments || [];
      const uniqueApartments = payload.apartments.filter((item, index) => {
        return apartments.findIndex(t => t.apartment.id === item.apartment.id) === -1;
      });
      state.apartments = apartments.concat(uniqueApartments);
    }
    state.activityStatus = ActivityStatus.Loaded;
    if (payload.pagination) {
      state.pagination = payload.pagination;
    }

  },
  [APARTMENT_EXTEND_APARTMENTS] : (state: IApartmentState, apartment: IApartmentListingViewModel ) => {
    if(state.apartments && state.apartments.length) state.apartments.unshift(apartment)
  },
  [APARTMENT_SPLICE_APARTMENTS] : (state: IApartmentState, apartmentId : number ) => {
    if(state.apartments && state.apartments.length) {
      const apartmentIndex = state.apartments.map(apartment=> apartment.apartment.id ).indexOf(apartmentId)
      if(apartmentIndex !== -1) state.apartments = state.apartments.filter((apartment,index)=> index !== apartmentIndex )
    }
  },
  [APARTMENT_SET_APPARTMENT]: (state: IApartmentState, apartment: IApartmentListingViewModel) => {
    state.currentApartment = {
      ...state.currentApartment,
      ...apartment
    };
    state.activityStatus = ActivityStatus.Loaded;
  },
  [APARTMENT_SET_ZONE]: (state: IApartmentState, zone: any[]) => {
    state.currentApartmentZone = zone
  }
  , [APARTMENT_UPDATE_APARTMENTS]: (state: IApartmentState, payload?: { id: number, apartment_number: any, tenants: any[] }) => {
    if(state.apartments && state.apartments.length){
        state.apartments = state.apartments.map((currentApartment: IApartmentListingViewModel  )=> {
          if(currentApartment.apartment.id !== payload.id ) return currentApartment

          currentApartment.apartment = {
             ...currentApartment.apartment,
             apartment_number: payload.apartment_number,
             totalTenant: payload.tenants.length
          }

          return currentApartment
       })
    }
  }
  , [APARTMENT_UPDATE_SIDEBAR_APARTMENTS]: (state: IApartmentState, payload?: { id: number, apartment_number: any }) => {
    state.sidebarApartments= state.sidebarApartments.map((currentApartment: IApartmentListingViewModel) =>{
      if(currentApartment.apartment.id !== payload.id) return currentApartment
      currentApartment.apartment = {
        ...currentApartment.apartment,
        apartment_number: payload.apartment_number
      }

      return currentApartment
    })
  }
  , [APARTMENT_RESET_APPARTMENTS]: (state: IApartmentState) => {
    state.pagination = new Pagination({ total: 0, limit: 0, skip: 0 });
    state.apartments = [];
    state.activityStatus = ActivityStatus.NoActivity;
  }
  , [APARTMENT_SET_SIDEBAR_APPARTMENTS]: (state: IApartmentState, sidebarApartments: IApartmentListingViewModel[]) => {
    state.sidebarApartments = sidebarApartments;
  }
  , [APARTMENT_EXTEND_SIDEBAR_APARTMENTS] : (state: IApartmentState, apartment: IApartmentListingViewModel ) => {
    if(state.sidebarApartments && state.sidebarApartments.length < 3)
        state.sidebarApartments = [ apartment, ...state.sidebarApartments ]
  }
  , [APARTMENT_SPLICE_SIDEBAR_APARTMENTS] : (state: IApartmentState, apartmentId: number ) => {
    if(state.sidebarApartments && state.sidebarApartments.length && state.sidebarApartments.length < 4 ) {

      const apartmentIndex= state.sidebarApartments.map(apartment=> apartment.apartment.id ).indexOf(apartmentId)
      if(apartmentIndex !== -1) state.sidebarApartments = state.sidebarApartments.filter((apartment,index)=> apartmentIndex !== index )
    }
  }
  , [APARTMENT_SET_APPARTMENTS_PARAMETER_PARTIAL]: (state: IApartmentState, payload: IApartmentParameter) => {
    state.apartmentParameter = Object.assign({}, state.apartmentParameter, payload);
  },
  [APARTMENT_ACTION] : (state: IApartmentState, crudAction: CrudStatus ) => {
     state.crudActionStatus= crudAction
  },
  [APARTMENT_SET_ZONE_ACTION] : (state: IApartmentState, crudAction: CrudStatus ) => {
     state.zoneAction = crudAction
  }
  , [APARTMENT_SET_LOCATION_NUMBER]: (state: IApartmentState, { location_number }) => {
    state.currentApartment.location_number = location_number
  }
}



// WEBPACK FOOTER //
// ./src/store/apartment/apartment-mutations.store.ts